import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../../shared/shared.module';
import {MatDividerModule} from '@angular/material/divider';
import {MatDialogModule} from '@angular/material/dialog';
import { EnvSchedulePopupComponent } from './env-schedule-popup-component';
import {IconsModule} from '../../icons/icons.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { ErrorModule } from '../error/error.module';


@NgModule({
  declarations: [EnvSchedulePopupComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatDividerModule,
    MatDialogModule,
    IconsModule,
    FormsModule,
    ReactiveFormsModule,
    ErrorModule
  ]
})
export class EnvSchedulePopupComponentModule {
}

